import {
  ROLE_ASSET_MANAGER,
  ROLE_BUYER,
  ROLE_C_ADMIN,
  ROLE_GUEST,
  ROLE_SELLER,
} from "../../../Utils/constant";

import { assetSlice } from "./assetSlice";

const { actions } = assetSlice;

export const loading = loader => dispatch => {
  return dispatch(actions.assetListLoading(loader));
};

export const list = payload => dispatch => {
  return dispatch(actions.assetList(payload));
};

export const setLastBid = payload => dispatch => {
  return dispatch(actions.setLastBid(payload));
};

export const setMergePopupOpen = payload => dispatch => {
  return dispatch(actions.setMergePopupOpen(payload));
};

export const setFocusOnMsgField = payload => dispatch => {
  return dispatch(actions.setFocusOnMsgField(payload));
};

export const chatlist = payload => dispatch => {
  const { result, count } = payload;

  const Offers = result.filter(obj => obj.isOffer);

  const lastOffer = Offers.reverse().find(obj => obj.isOffer);

  return dispatch(actions.chatList({ result, count, lastOffer }));
};

export const updateMessageList = payload => dispatch => {
  return dispatch(actions.updateChatList(payload));
};

export const listLoad = payload => dispatch => {
  return dispatch(actions.listLoad(payload));
};

export const setAssetInList = payload => dispatch => {
  return dispatch(actions.setAssetInList(payload));
};

export const setAssetCList = payload => dispatch => {
  return dispatch(actions.setAssetCList(payload));
};

export const loadCategory = payload => dispatch => {
  return dispatch(actions.loadAssetForEdit(payload));
};

export const loadCategoryMessage = payload => dispatch => {
  return dispatch(actions.loadAssetMessage(payload));
};

export const loadState = payload => dispatch => {
  return dispatch(actions.loadState(payload));
};

export const setTab = payload => dispatch => {
  return dispatch(actions.setTab(payload));
};

export const setChatRoomId = payload => dispatch => {
  return dispatch(actions.setChatRoomId(payload));
};

export const setAssetDetail = payload => dispatch => {
  return dispatch(actions.setAssetDetail(payload));
};

export const setOpenOfferModel = payload => dispatch => {
  return dispatch(actions.setOpenOfferModel(payload));
};

export const setAcceptOfferModel = payload => dispatch => {
  return dispatch(actions.setAcceptOfferModel(payload));
};

export const chatRoomExist = payload => dispatch => {
  return dispatch(actions.chatRoomExist(payload));
};

export const bidlist = payload => dispatch => {
  return dispatch(actions.bidlist(payload));
};

export const updateBidList = payload => dispatch => {
  return dispatch(actions.updateBidList(payload));
};

export const updateLastBidList = payload => dispatch => {
  return dispatch(actions.updateLastBidList(payload));
};

export const updateSellerBidList = payload => dispatch => {
  return dispatch(actions.updateSellerBidList(payload));
};

export const setIsSignupSuccessfull = payload => dispatch => {
  return dispatch(actions.setIsSignupSuccessfull(payload));
};

export const setIsAccepted = payload => dispatch => {
  return dispatch(actions.setIsAccepted(payload));
};

export const chatRoomList = payload => dispatch => {
  let name = "";
  const { rooms, sellerId } = payload;

  rooms.map((room, index) => {
    const orgName = room.users.find(obj => obj.organization?.name);

    if (!orgName) {
      name = room.users.find(
        obj => obj.roles.findIndex(val => val?.key !== ROLE_ASSET_MANAGER) > -1,
      );
    }

    const seller =
      room.buyer.roles.findIndex(obj => obj.key === ROLE_SELLER) > -1;

    const buyer =
      room.buyer.roles.findIndex(obj => obj.key === ROLE_BUYER) > -1;

    const companyAdmin =
      room.buyer.roles.findIndex(obj => obj.key === ROLE_C_ADMIN) > -1;

    let roles =
      sellerId === room.buyer.id
        ? "a"
        : seller
          ? "b"
          : buyer
            ? "c"
            : companyAdmin
              ? "d"
              : ROLE_GUEST;

    rooms[index].role = roles;
    rooms[index].roomName = name?.displayName;
    rooms[index].participants = room.users.length;
  });
  rooms.sort((a, b) => {
    const roleA = a.role;

    const roleB = b.role;

    if (roleA < roleB) {
      return -1;
    }

    if (roleA > roleB) {
      return 1;
    }

    return 0;
  });
  return dispatch(actions.chatRoomList(rooms));
};

export const updateChatListInObj = payload => dispatch => {
  const { list, resp } = payload;

  const newlist = [...list];

  const elementsIndex = newlist.findIndex(element => element.id === resp.id);

  newlist[elementsIndex] = {
    ...newlist[elementsIndex],
    updatedBy: resp.updatedBy,
    isDeclined: resp.isDeclined,
    isCancelled: resp.isCancelled,
    isCancel: resp.isCancel,
    isAccept: resp.isAccept,
    count: resp.message,
    status: resp.status,
    url: resp.url,
    reason: resp.reason,
  };
  return dispatch(actions.updateChatListInObj(newlist));
};

export const setAccessData = payload => dispatch => {
  return dispatch(actions.setAccessData(payload));
};

export const internalChatRoomExist = payload => dispatch => {
  return dispatch(actions.internalChatRoomExist(payload));
};

export const setIsUsersAddedInChat = payload => dispatch => {
  return dispatch(actions.setIsUsersAddedInChat(payload));
};

export const addAssetInWishlist = payload => dispatch => {
  return dispatch(actions.addAssetInWishlist(payload));
};

export const setParticipantsId = payload => dispatch => {
  return dispatch(actions.setParticipantId(payload));
};

export const addAssetInCustomList = payload => dispatch => {
  return dispatch(actions.addAssetInCustomList(payload));
};

export const setIsOfferForSeller = payload => dispatch => {
  return dispatch(actions.setIsOfferForSeller(payload));
};

export const setEventTarget = payload => dispatch => {
  return dispatch(actions.setEventTarget(payload));
};

export const showStickyHeader = payload => dispatch => {
  return dispatch(actions.showStickyHeader(payload));
};

export const setIsAcceptedStatus = payload => dispatch => {
  return dispatch(actions.setIsAcceptedStatus(payload));
};

export const setIsAssetPurchased = payload => dispatch => {
  return dispatch(actions.isAssetPurchased(payload));
};

export const updateTimerStatus = payload => dispatch => {
  return dispatch(actions.updateTimerStatus(payload));
};

export const setAssetinWishList = payload => dispatch => {
  return dispatch(actions.setAssetinWishList(payload));
};

export const setIsCancelledOffer = payload => dispatch => {
  return dispatch(actions.setIsCancelledOffer(payload));
};

export const setIsDeclineOffer = payload => dispatch => {
  return dispatch(actions.setIsDeclineOffer(payload));
};

export const timerObj = payload => dispatch => {
  return dispatch(actions.setTimerObj(payload));
};

export const selectedOffer = payload => dispatch => {
  return dispatch(actions.selectOfferObj(payload));
};

export const setIsSeller = payload => dispatch => {
  return dispatch(actions.setIsSeller(payload));
};

export const setOfferedPrice = payload => dispatch => {
  return dispatch(actions.setOfferedPrice(payload));
};

export const setIsOfferAcctoAP = payload => dispatch => {
  return dispatch(actions.setIsOfferAcctoAP(payload));
};

export const setArchiveDialogData = payload => dispatch => {
  return dispatch(actions.setArchiveDialogData(payload));
};

export const setDeleteDialogData = payload => dispatch => {
  return dispatch(actions.setDeleteDialogData(payload));
};

export const setIsAssetManager = payload => dispatch => {
  return dispatch(actions.setIsAssetManager(payload));
};
